import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ApiClass } from '@data/class/api-class'
import { IResponse, IResponseArray } from '@data/interfaces/iresponseArray.interface'
import { environment } from '@env/environment'
import { IChannelSource } from '../../interfaces/channel-source.interface'

@Injectable({ providedIn: 'root' })
export class ApiChannelSourcesService extends ApiClass {
  constructor() {
    super()
    this.path = 'channel-sources'
  }

  //* contrato que consume MainTableComponent (page, limit, filters) → { data: { totalItems, data } }
  getAll(page: number, limit: number, filters: any = {}): Observable<IResponseArray> {
    return this.http.post<IResponseArray>(`${environment.apiUrl}${this.path}`, { page, limit, filters })
  }

  getById(id: string): Observable<IResponse> {
    return this.getCollection(id)
  }

  create(payload: { key: string; label: string; actorRoleRequired?: string | null; description?: string }): Observable<IResponse> {
    return this.postCollection(payload, 'create')
  }

  update(id: string, payload: Partial<IChannelSource>): Observable<IResponse> {
    return this.patchCollection(payload, environment.apiUrl, `${this.path}/${id}`)
  }

  remove(id: string): Observable<IResponse> {
    return this.deleteCollection(id)
  }
}
